import React from 'react';
import moment from 'moment';
import * as XLSX from 'xlsx';

import Loader from './../../../component/common/Loader';
import CONSTANT from '../../../constant';
import Header from '../../../component/common/LeaveHeader';
import { getUnitList } from '../../../actions/MasterAction';
import { getLeaveMonthlyLeaveReport } from '../../../actions/LeaveAction';
import { onChange, validateForm,setOptions } from '../../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        // const startDate = moment().startOf('month').format('YYYY-MM-DD');
        // const startDate = moment().startOf('month').format('YYYY-MM-DD');
        // const endOfMonth = moment().endOf('month').format('YYYY-MM-DD');
        const endOfMonth = moment().format('YYYY-MM');
        this.state = {
            // startDate: { name: 'startDate', value: startDate, error: '', isRequired: true },
            endDate: { name: 'endDate', value: endOfMonth, error: '', isRequired: true },
            unitCode: { name: 'unitCode', value: '', options: [], error: '' },
            list: [],
            showLoader: false
        }
    }

    componentDidMount() {
        
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;
        getUnitList().then((res: any) => {
            setOptions(this, this.state.unitCode.name, res.result);
        });
    }

    render() {
        const { startDate, endDate, list, showLoader, unitCode } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Monthly Leave Report</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-7"></div>
                            <div className="col-md-5">
                                <div className="card">
                                    <div className="card-header">View Leave Balance For</div>
                                    <div className="card-body">
                                        <form onSubmit={this.onSubmit}>
                                            <div className="row">
                                                {/* <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Start Date *</label>
                                                        <input
                                                            type="date"
                                                            className={startDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            name={startDate.name}
                                                            value={startDate.value}
                                                            onChange={this.onChange}
                                                            max={moment().format('YYYY-MM')}
                                                        />
                                                    </div>
                                                </div> */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Month *</label>
                                                        <input
                                                            type="month"
                                                            className={endDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            name={endDate.name}
                                                            value={endDate.value}
                                                            onChange={this.onChange}
                                                            max={moment().format('YYYY-MM')}
                                                        // min={moment(startDate.value).format('YYYY-MM')}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Unit</label>
                                                    <select
                                                        value={unitCode.value}
                                                        className={unitCode.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        onChange={this.onChange}
                                                        name={unitCode.name}
                                                        disabled={list.length === 0}>    
                                                        <option value="">Filter By Unit</option>
                                                        {
                                                            unitCode.options.map((item: any, index: number) => {
                                                                return <option key={index} value={item.name}>{item.name}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <button type="button" disabled={list.length === 0} onClick={this.downloadExcel} className="btn btn-sm submit-button btn-block">Download Report</button>
                                                </div>
                                                <div className="col-md-6">
                                                    <button type="submit" className="btn btn-sm submit-button btn-block">Search</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Employee Number</th>
                                                <th scope="col">Name</th>
                                                <th scope="col" title="Casual leave">CL</th>
                                                <th scope="col" title="RH">RH</th>
                                                <th scope="col" title="Encashable">EL</th>
                                                <th scope="col" title="Non-Encashable">NON-EL</th>
                                                <th scope="col" title="HPL">HPL</th>
                                                <th scope="col" title="HPL">Unit</th>
                                            </tr>
                                            {
                                                list === undefined && <tr>
                                                    <td colSpan={10} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.length === 0 && <tr>
                                                    <td colSpan={10} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.filter((item: any) => unitCode.value ? item.unitName == unitCode.value : true).map((item: any, index: number) => {
                                                    // const detailPageURL = `${CONSTANT.component.adminAddLeave}?code=${item.code}`;
                                                    let temp;
                                                    const cl = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.cl)[0];
                                                    if( cl.total < cl.used){
                                                        temp = cl.total;
                                                        cl.total = cl.used;
                                                        cl.used = temp;                       
                                                    }
                                                    const rh = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.rh)[0];
                                                    const el = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.el)[0];
                                                    if( el.total < el.used){
                                                        temp = el.total;
                                                        el.total = el.used;
                                                        el.used = temp;                       
                                                    }
                                                    const nonel = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.nonel)[0];
                                                    const hpl = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.hpl)[0];;
                                                    return (
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>{item.employeeNumber}</td>
                                                            <td>{item.name}</td>
                                                            <td>
                                                                {`${cl.total - cl.used}`}
                                                            </td>
                                                            <td>
                                                                {`${rh.total - rh.used}`}
                                                            </td>
                                                            <td>
                                                                {`${el.total - el.used}`}
                                                            </td>
                                                            <td>
                                                                {`${nonel.total - nonel.used}`}
                                                            </td>
                                                            <td>
                                                                {`${hpl.total - hpl.used}`}
                                                            </td>
                                                            <td>{item.unitName}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div >
        )
    }


    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            this.setState({ showLoader: true });
            const { endDate } = this.state;
            const startOfYear = moment(moment(endDate.value, 'YYYY-MM-DD')).startOf('year').format('YYYY-MM-DD');
            const endOfMonth = moment(moment(endDate.value, 'YYYY-MM-DD')).endOf('month').format('YYYY-MM-DD');
            getLeaveMonthlyLeaveReport(startOfYear, endOfMonth).then((res: any) => {
                this.setState({ list: res.result, showLoader: false });
            });
        }

    }

    onChange = (e: any) => {
        const name = e.target.name;
        let value = e.target.value;
        onChange(this, name, value);
    }

    downloadExcel = (e: any) => {
        const { list, endDate } = this.state;

        const date = moment(endDate.value);
        if (list.length === 0) {
            alert('No records found.');
            return;
        }
        let filename = `leave - balance - ${date.format('MMMM-YYYY')}.xlsx`;
        let dataToExport: any = [];
        var ws_name = "Sheet1";
        const { unitCode } = this.state;
        list.filter((item: any) => unitCode.value ? item.unitName == unitCode.value : true).map((item: any, index: number) => {
            delete item.code;
            const cl = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.cl)[0];
            const el = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.el)[0];
            const nonel = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.nonel)[0];
            const hpl = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.hpl)[0];
            const rh = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.rh)[0];
            const dated = date.format('MMM YYYY');

            dataToExport.push({
                EmployeeNumber: item.employeeNumber,
                Name: item.name,
                Dated: dated,
                Unit: item.unitName,

                "CL Total": cl.total,
                "CL Used": cl.used,
                "RH Total": rh.total,
                "RH Used": rh.used,
                "EL Total": el.total,
                "EL Used": el.used,
                "NON-EL Total": nonel.total,
                "NON-EL Used": nonel.used,
                "HPL Total": hpl.total,
                "HPL Used": hpl.used
            });
        });
        var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(dataToExport);
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, filename);
        // });
    }
}

export default ComponentName;